import { styled, css, keyframes } from "styled-components";

interface UserCardProps {
    $show: boolean;
    $animate: boolean;
}

const CardKeyframesIN = keyframes`
    0%{
        height: 0;
        padding-bottom: 0;
        opacity: 0;
    }
    10%{
        padding-bottom: 20px;
        height: 700px;
        opacity: 0;
    }
    20%{
        padding-bottom: 20px;
        height: 700px;
        opacity: 1;
    }
    100%{
        padding-bottom: 20px;
        height: 700px;
        opacity: 1;
    }
`;

const CardKeyframesOut = keyframes`
    0%{
        opacity: 1;
        height: 700px;
        padding-bottom: 20px;
    }
    10%{
        opacity: 0;
        height: 700px;
        padding-bottom: 20px;
    }
    20%{
        height: 0px;
        opacity: 0;
        padding-bottom: 0px;
    }
    100%{
        opacity: 0;
        height: 0px;
        padding-bottom: 0px;
    }
`;

// transition: ${(props) => props.theme.animationTime.short}s all ease;

export const UserCard = styled.div<UserCardProps>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    animation-fill-mode: forwards;
    animation-iteration-count: 1;
    ${(props) =>
        !props.$animate && props.$show
            ? css`
                  height: 700px;
                  padding-bottom: 20px;
              `
            : ""}
    ${(props) =>
        !props.$animate && !props.$show
            ? css`
                  height: 0px;
              `
            : ""}
    ${(props) =>
        props.$animate && props.$show
            ? css`
                  animation: ${CardKeyframesIN} ${props.theme.animationTime.medium}s;
                  height: 700px;
                  padding-bottom: 20px;
                  opacity: 1;
                  border-bottom: 1px solid ${(props) => props.theme.colors.accentMain};
              `
            : ""}
    ${(props) =>
        props.$animate && !props.$show
            ? css`
                  animation: ${CardKeyframesOut} ${props.theme.animationTime.medium}s;
                  height: 0px;
              `
            : ""}
`;

export const UserContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const UserCardTitleAndXP = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width: 100%;
    align-items: center;
    padding-left: 5%;
    padding-right: 5%;
    padding-bottom: 5%;
    padding-top: 2%;
`;

export const UserCardTitleAndCoins = styled.div``;

export const UserCardCoinsImageAndAmount = styled.div`
    display: flex;
    align-items: center;
`;

export const UserCardCoinsAmount = styled.div`
    font-size: 12px;
    font-weight: 600;
    padding-left: 5px;
`;
export const UserCardCoins = styled.img`
    width: 12px;
    height: 12px;
`;

export const UserCardTitle = styled.div`
    font-size: 25px;
    font-weight: 600;
`;

export const UserCardXP = styled.div`
    display: flex;
    flex-direction: column;
    align-items: right;
`;

export const UserCardXPName = styled.div`
    color: ${(props) => props.theme.colors.accentMain};
    text-transform: uppercase;
`;

export const UserInventoryDisplay = styled.div`
    width: 90%;
    border: 1px solid ${(props) => props.theme.colors.accentOne};
    border-radius: 5px;
    display: flex;
    align-items: center;
    padding-top: 5px;
    padding-bottom: 5px;
    flex-direction: column;
    vertical-align: top;
    flex-wrap: wrap;
    overflow-y: auto;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        flex-wrap: nowrap;
    }
`;

export const UserCardXPValue = styled.div``;

interface UserCardItemProps {
    $manyItems: boolean;
}

export const UserCardItem = styled.div<UserCardItemProps>`
    width: ${(props) => (props.$manyItems ? "40" : "80")}%;
    padding-left: 5px;
    padding-right: 5px;
    padding-top: 2px;
    padding-bottom: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    @media screen and (max-width: ${(props) => props.theme.breakpoint}px) {
        width: 90%;
    }
`;

export const UserCardItemName = styled.div`
    text-transform: uppercase;
    font-size: 13px;
`;

export const UserCardItemAmount = styled.div`
    font-size: 13px;
`;

interface UserStateIconProps {
    $showingCard: boolean;
}

export const UserIconsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 30%;
`;

export const UserStateIcon = styled.img<UserStateIconProps>`
    width: 20px;
    height: 20px;
    transition: ${(props) => props.theme.animationTime.short / 2}s all ease;
    transform: ${(props) => (props.$showingCard ? "rotate(180deg)" : "rotate(90deg)")};
`;
